import * as yup from "yup";

// import { initialValues as initialValuesUom , validationSchema as validationSchemaUom } from "./itemSchema";
// import { initialValues as initialValuesSan, validationSchema as validationSchemaScan } from "./itemSettingSchema";

export const validationSchema = yup.object(
    {
        name: yup
            .string()
            .required('Required'),
        model: yup
            .string()
            .required("Required"),
        productCode: yup
            .string()
            .required("Required"),
        // description: yup
        //     .string()
        //     .required("Required"), 
        // summary: yup
        //     .string()
        //     .required("Required"),
        // brand: yup
        //     .string()
        //     .required("Required"), 
        // categoryList: yup
        //     .string()
        //     .required("Required"),
        uomId: yup
            .string()
            .required('Required'),
        // brandId: yup
        //     .string()
        //     .required("Required"),
        // categoryLevel0Id: yup
        //     .string()
        //     .required("Required"),

        // ...validationSchemaUom,
        // ...validationSchemaScan

    }
)

export const initialValues = {
    name: "",
    model: "",
    productCode: "",
    description: "",
    summary: "",
    // brand: "",
    // categoryList: "",
    uomId: "",
    brandId: "",

    categoryLevel0Id: "",
    categoryLevel1Id: "",
    categoryLevel2Id: "",
    status: true,
    // ...initialValuesUom,
    // ...initialValuesSan
}